import React, { useCallback, useEffect, useState } from 'react';
import ModalBasic from '../../../components/Modal';
import EditIcon from '../../../components/Icons/EditIcon';
import ClientButton from '../../../components/ClientButton';

import AddIcon from '../../../components/Icons/AddIcon';
import DeleteIcon from '../../../components/Icons/DeleteIcon';
import ModalWithHeading from '../../../components/ModalWithHeading';
import ModalWithHeadingSmall from '../../../components/ModalWithHeadingSmall';
import { toast } from 'react-hot-toast';
import Loader from '../../../components/Loader';
import { updateProfileApi } from '../../../redux/Reducers/MyAccountReducer';
import { useDispatch } from 'react-redux';
import { getProfileDataApi } from '../../../redux/Reducers/ProfileReducer';
import PhoneField from '../../../components/PhoneField';
import Button from '../../../components/Button';
import { phone_add_plus_one } from '../../../utils/commonUtil';

// AddressList same as AddMemberModal
const AddressList = ({ options = [], value = [], onChange }) => {
  const checkedIds = (value || []).map((v) => String(v.service_address_id));
  const toggle = (id) => {
    const exists = checkedIds.includes(String(id));
    let next = [...(value || [])];
    if (exists) {
      next = next.filter((v) => String(v.service_address_id) !== String(id));
    } else {
      next.push({ service_address_id: String(id), operation: 'CREATE' });
    }
    onChange?.(next);
  };
  return (
    <>
      {options?.map((option) => (
        <label className='flex' key={option?.id}>
          <input
            onChange={() => toggle(option?.id)}
            checked={checkedIds.includes(String(option?.id))}
            type='checkbox'
            value={option?.id}
            className='form-checkbox mt-1.5'
          />
          <span className='go-textblacknormal-16 ml-2 pt-0.5'>{option?.full_address}</span>
        </label>
      ))}
    </>
  );
};

export default function EditMemberModal({ modalOpen, setModalOpen, data, member }) {
  const dispatch = useDispatch();
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteModal, setdeleteModal] = useState(false);
  const [selectedMemberToDelete, setSelectedMemberToDelete] = useState(null);
  const deleteModalFn = useCallback((e, val, member) => {
    e.stopPropagation();
    setdeleteModal(val);
    setSelectedMemberToDelete(member);
  }, []);
  const deleteMemberFn = () => {
    setDeleteLoading(true);
    const payload = { members: [{ id: selectedMemberToDelete?.id, operation: 'DELETE' }] };
    const create = updateProfileApi(payload);
    create?.then((res) => {
      if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
        setDeleteLoading(false);
        toast.success('Member deleted successfully!');
        setdeleteModal(false);
        setSelectedMemberToDelete(null);
        dispatch(getProfileDataApi(false));
      } else {
        setDeleteLoading(false);
        toast.error(res?.error?.message || 'Something went wrong');
      }
    });
  };

  // Edit form state
  const [formData, setFormData] = useState({
    first_name: member?.first_name || '',
    last_name: member?.last_name || '',
    email: member?.email || '',
    phone_number: member?.phone_numbers?.[0]?.phone_number || '',
    service_addresses: member?.addresses?.map((a) => ({ service_address_id: String(a.id) })) || [],
  });
  const [formErrors, setFormErrors] = useState({});
  const [editLoadingLocal, setEditLoadingLocal] = useState(false);

  useEffect(() => {
    setFormData({
      first_name: member?.first_name || '',
      last_name: member?.last_name || '',
      email: member?.email || '',
      phone_number: member?.phone_numbers?.[0]?.phone_number || '',
      service_addresses: member?.addresses?.map((a) => ({ service_address_id: String(a.id) })) || [],
    });
  }, [member]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleAddressesChange = (addresses) => {
    setFormData((prev) => ({ ...prev, service_addresses: addresses }));
  };

  const validate = () => {
    const errors = {};
    if (!formData.first_name?.trim()) errors.first_name = 'First name is required';
    if (!formData.last_name?.trim()) errors.last_name = 'Last name is required';
    if (!formData.email?.trim()) errors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) errors.email = 'Email is invalid';
    if (!formData.phone_number || formData.phone_number.length < 12) errors.phone_number = 'Phone number is required';
    if (
      !formData.service_addresses ||
      (Array.isArray(formData.service_addresses) && formData.service_addresses.length === 0)
    )
      errors.service_addresses = 'Please select at least one service address';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const onSubmit = (e) => {
    e?.preventDefault?.();
    if (!validate()) return;
    setEditLoadingLocal(true);
    const temp = { id: member?.id, operation: 'UPDATE' };
    if (formData.first_name !== member?.first_name) temp.first_name = formData.first_name;
    if (formData.last_name !== member?.last_name) temp.last_name = formData.last_name;
    if (formData.email !== member?.email) temp.email = formData.email;
    // phone_number: keep api format
    if (formData.phone_number !== member?.phone_numbers?.[0]?.phone_number)
      temp.phone_number = { phone_number: phone_add_plus_one(formData.phone_number) };
    if (formData.service_addresses) {
      const newAddresses = formData.service_addresses.filter((item) => item?.operation === 'CREATE');
      const delAddresses = formData.service_addresses.filter((item) => item?.operation === 'DELETE');
      const addr = [...(newAddresses || []), ...(delAddresses || [])];
      if (addr.length) temp.service_addresses = addr;
    }
    const payload = { members: [temp] };
    updateProfileApi(payload).then((res) => {
      setEditLoadingLocal(false);
      if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
        toast.success('Member updated successfully!');
        setModalOpen(false);
        dispatch(getProfileDataApi(false));
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    });
  };
  return (
    <>
      <ModalBasic
        id='edit-member-modal'
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        title={'Edit Member'}
        width='md'
      >
        <div className='p-6'>
          {editLoadingLocal ? (
            <Loader text='processing...' classes=' h-96' />
          ) : (
            <form onSubmit={onSubmit}>
              <div>
                <div className=' flex space-x-2'>
                  <div className=' mb-4 flex-row space-y-1.5'>
                    <label className='go-label-16 mb-1 block' htmlFor='label'>
                      First Name
                    </label>
                    <input
                      name='first_name'
                      className={`go-inputtext-16`}
                      value={formData.first_name}
                      onChange={handleChange}
                      type='text'
                    />
                    {formErrors.first_name && <p className='go-textnormal-14 text-red-500'>{formErrors.first_name}</p>}
                  </div>
                  <div className=' mb-4 flex-row space-y-1.5'>
                    <label className='go-label-16 mb-1 block' htmlFor='label'>
                      Last Name
                    </label>
                    <input
                      name='last_name'
                      className={`go-inputtext-16`}
                      value={formData.last_name}
                      onChange={handleChange}
                      type='text'
                    />
                    {formErrors.last_name && <p className='go-textnormal-14 text-red-500'>{formErrors.last_name}</p>}
                  </div>
                </div>
                <div className='relative mb-4 flex-row space-y-1.5'>
                  <label className='go-label-16 mb-1 block' htmlFor='label'>
                    Email
                  </label>
                  <input
                    name='email'
                    value={formData.email}
                    onChange={handleChange}
                    className={`go-inputtext-16 ${formErrors?.email ? 'border-red-500' : ''}`}
                    type='email'
                  />
                  {formErrors.email && <p className='go-textnormal-14 text-red-500'>{formErrors.email}</p>}
                </div>
                <div className='relative mb-4 flex-row space-y-1.5'>
                  <PhoneField
                    required
                    label='Phone'
                    name='phone_number'
                    value={formData.phone_number}
                    onChange={(e, apiValue) => {
                      if (apiValue) {
                        setFormData((prev) => ({ ...prev, phone_number: apiValue }));
                      } else if (e?.target) {
                        handleChange(e);
                      }
                    }}
                    error={formErrors.phone_number}
                  />
                </div>
                <div className='min- relative mb-4 flex-row space-y-1.5'>
                  <label className='go-label-16  mb-1 block' htmlFor='label'>
                    Service Address
                  </label>
                  <AddressList
                    options={data?.addresses}
                    value={formData.service_addresses}
                    onChange={handleAddressesChange}
                  />
                  {formErrors.service_addresses && (
                    <p className='go-textnormal-14 mt-2 text-red-500'>{formErrors.service_addresses}</p>
                  )}
                </div>
              </div>
            </form>
          )}
          <div className='flex space-x-4 p-5'>
            <Button
              variant='secondary'
              text='Cancel'
              classes='w-full'
              onClick={() => {
                setModalOpen(false);
              }}
            />
            <Button variant='primary-dark' text='Save' classes='w-full' onClick={onSubmit} />
          </div>
        </div>
      </ModalBasic>

      <ModalWithHeadingSmall
        modalOpen={deleteModal}
        setModalOpen={setdeleteModal}
        title={`Are you sure you want to remove ${selectedMemberToDelete?.first_name}?`}
        classes='max-w-2xl py-10'
      >
        <div className='mx-8'>
          {deleteLoading ? <Loader text='processing...' classes='h-44 ' /> : null}
          <div className='flex-col justify-center py-2 text-center '>
            <ClientButton
              variant='secondary'
              text='Cancel'
              classes=''
              onClick={() => {
                setdeleteModal(false);
              }}
            />
            <ClientButton
              variant='cancel'
              text='Yes'
              classes=''
              onClick={() => {
                deleteMemberFn();
              }}
            />
          </div>
        </div>
      </ModalWithHeadingSmall>
    </>
  );
}
